import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';
import { PowerBiEmbedComponent } from './components/power-bi-embed/power-bi-embed.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { SensorsComponent } from './pages/sensors/sensors.component';
import { SustainabilityComponent } from './pages/sustainability/sustainability.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'reports',
    pathMatch: 'full',
  },
  {
    path: 'analytics',
    component: ReportsComponent,
    canActivate: [MsalGuard],
    data: { title: 'Analytics' },
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [MsalGuard],
    data: { title: 'Analytics' },
  },
  // {
  //   path: 'reports/:category',
  //   component: ReportsComponent,
  //   canActivate: [MsalGuard],
  //   data: { title: 'Analytics' },
  // },
  {
    path: 'reports/general',
    component: ReportsComponent,
    canActivate: [MsalGuard],
    data: { title: 'Analytics' },
  },
  {
    path: 'reports/sustainability',
    component: ReportsComponent,
    canActivate: [MsalGuard],
    data: { title: 'Analytics' },
  },
  {
    path: 'reports/finance',
    component: ReportsComponent,
    canActivate: [MsalGuard],
    data: { title: 'Analytics' },
  },
  {
    path: 'reports/iot',
    component: ReportsComponent,
    canActivate: [MsalGuard],
    data: { title: 'Analytics' },
  },
  {
    path: 'advanceReport/:reportId',
    component: PowerBiEmbedComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Analytics',
      hideSubNav: true,
    },
  },
  // {
  //   path: 'analytics/diversionAnalysis/8111d7a7-15d2-4e4a-93a7-3525a8e67aa7',
  //   component: PowerBiEmbedComponent,
  //   canActivate: [MsalGuard],
  //   data: {
  //     title: 'Analytics',
  //     hideSubNav: true,
  //   },
  // },
  // {
  //   path: 'analytics/rollOffAnalysis/8c1bbc60-14f4-470a-a68f-1077ec7c977b',
  //   component: PowerBiEmbedComponent,
  //   canActivate: [MsalGuard],
  //   data: {
  //     title: 'Analytics',
  //     hideSubNav: true,
  //   },
  // },
  {
    path: 'sustainability',
    component: SustainabilityComponent,
    canActivate: [MsalGuard],
    data: { title: 'Sustainability' },
  },
  {
    path: 'sensors',
    component: SensorsComponent,
    canActivate: [MsalGuard],
    data: { title: 'Sensors' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnalyticsRoutingModule {}
